import { DatePicker } from "antd";
import dayjs from "dayjs";
import * as React from "react";
import Text from "../text";

interface Handles {
  focus: () => void;
}

interface IProps {
  value: Date;
  id: string;
  label?: string;
  simpleMode?: boolean;
  icon?: React.ReactNode;
  size: any;
  placeholder?: string;
  format?: string;
  className?: string;
  required?: boolean;
  readOnly?: boolean;
  allowClear?: boolean;
  autoFocus?: boolean;
  backgroundColor?: string;
  error?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}

const DateField = React.forwardRef<Handles, IProps>(
  (
    {
      id,
      label,
      simpleMode = false,
      value,
      icon,
      className,
      size = "small",
      placeholder = " ",
      format = "YYYY-MM-DD",
      error,
      allowClear = true,
      readOnly = false,
      backgroundColor = "bg-white",
      autoFocus = false,
      required = false,
      disabled = false,
      onChange,
      onBlur,
    }: IProps,
    ref
  ) => {
    const inputRef = React.useRef<any>(null);
    const [open, setOpen] = React.useState<boolean>(false);

    React.useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    return (
      <div className="flex flex-col flex-1">
        <div
          className={
            simpleMode
              ? ``
              : `flex flex-1 relative border border-grey3 rounded-md overflow-hidden  ${backgroundColor} ${
                  error && "!border-red"
                }`
          }
        >
          {icon && <div className="flex items-center ml-3 w-6 ">{icon}</div>}
          <div className="flex flex-col flex-1 relative">
            <span
              onClick={() => setOpen(true)}
              className={
                simpleMode
                  ? `  ${className}  w-full`
                  : `${className} disabled:bg-grey focus:border-none focus:ring-0 focus:ring-offset-0 appearance-none block w-full peer  ${
                      icon ? "!pr-3 !pl-[15px]" : "px-3"
                    } ${
                      label
                        ? "text-15 !pt-[26px] !pb-[10px] !pl-[16px "
                        : "py-2"
                    } !border-none bg-transparent !select-none`
              }
            >
              {!value ? "Any" : dayjs(value).format(format)}
            </span>
            <DatePicker
              open={open}
              id={id}
              ref={inputRef}
              name={id}
              suffixIcon={<></>}
              format={format}
              onOpenChange={(open) => setOpen(open)}
              disabledDate={(current) => {
                return current && current < dayjs().startOf("day");
              }}
              onBlur={onBlur}
              disabled={disabled}
              placeholder={placeholder}
              size={size}
              allowClear={allowClear}
              autoFocus={autoFocus}
              value={value ? dayjs(value) : dayjs()}
              onChange={(e) => {
                if (onChange) onChange(e.format("YYYY-MM-DD"));
              }}
              bordered={false}
              className={`invisible h-0 p-0 m-0`}
            />
            {label && (
              <label
                htmlFor={id}
                className="
              absolute text-16 font-semibold text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 translate-x-[2px] scale-75 top-[17px] z-10 origin-[0] left-3.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3
              peer-focus:translate-x-[2px]
              text-black/80
              peer-focus:text-black/80
              peer-placeholder-shown:text-grey4
              "
              >
                {label}
              </label>
            )}
          </div>
        </div>
        {error && (
          <div className="pt-1 pb-1">
            <Text size={11} color="red">
              {error}
            </Text>
          </div>
        )}
      </div>
    );
  }
);

export default DateField;
